module.exports = ''
+ '<nav class="creek-shows-nav">'
+ '  <ul>'
+ '    <li :class="[\'creek-shows-nav-weekday\', \'creek-weekday-\'+weekdayNumber, weekdayNumber == weekdaySelected ? \'creek-selected\' : \'\' ]" v-for="(weekdayTitle, weekdayNumber) in showsNavText.weekdays"><a :href="\'#/weekday/\'+weekdayNumber" :data-weekday="weekdayNumber" v-html="weekdayTitle"></a></li>'
+ '    <li class="creek-shows-nav-all"><a href="#/all" v-html="showsNavText.allShows"></a></li>'
+ '    <li class="creek-shows-nav-calendar"><a href="#/schedule" v-html="showsNavText.calendar"></a></li>'
+ '  </ul>'
+ '</nav>'


// WEBPACK FOOTER //
// ./src/templates/shows-nav.js